import { BoardValue } from '../../jscaip/AI/BoardValue';
import { CoordSet } from '../../jscaip/CoordSet';
import { Orthogonal } from '../../jscaip/Orthogonal';
import { Player } from '../../jscaip/Player';
import { TaflPawn } from './TaflPawn';
import { TaflPieceAndInfluenceHeuristic } from './TaflPieceAndInfluenceHeuristic';
export class TaflPieceAndControlHeuristic extends TaflPieceAndInfluenceHeuristic {
    getBoardValue(node, config) {
        const metrics = this.getControlScoreAndPieceScores(node, config);
        return BoardValue.multiMetric([
            metrics.safeScore,
            metrics.threatenedScore,
            metrics.controlScore,
        ]);
    }
    getControlScoreAndPieceScores(node, config) {
        const state = node.gameState;
        const pieceMap = this.getPiecesMap(state);
        const threatMap = this.getThreatMap(node, pieceMap);
        const filteredThreatMap = this.filterThreatMap(threatMap, state);
        const metrics = { safeScore: 0, threatenedScore: 0, controlScore: 0 };
        for (const owner of Player.PLAYERS) {
            let controlledSquares = new CoordSet();
            for (const coord of pieceMap.get(owner).get()) {
                if (filteredThreatMap.get(coord).isPresent()) {
                    metrics.threatenedScore += owner.getScoreModifier();
                }
                else {
                    metrics.safeScore += owner.getScoreModifier();
                    for (const dir of Orthogonal.ORTHOGONALS) {
                        let testedCoord = coord.getNext(dir, 1);
                        while (state.hasPieceAt(testedCoord, TaflPawn.UNOCCUPIED)) {
                            controlledSquares = controlledSquares.addElement(testedCoord);
                            testedCoord = testedCoord.getNext(dir, 1);
                        }
                    }
                }
            }
            for (const controlled of controlledSquares) {
                const controlledValue = this.getControlledPieceValue(controlled, state);
                metrics.controlScore += owner.getScoreModifier() * controlledValue;
            }
        }
        return metrics;
    }
    getControlledPieceValue(coord, state) {
        let value = 1;
        if (state.isHorizontalEdge(coord)) {
            value *= state.getWidth();
        }
        if (state.isVerticalEdge(coord)) {
            value *= state.getWidth();
        }
        /** 1 for center
          * width for border
          * width * width for corners
          */
        return value;
    }
}
